import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import "../Header/style.scss";
import { BsSearch } from "react-icons/bs";
import ProductsData from "../../../routes/home/Products/productsData";
import { accessories_array } from "../../../routes/accessories/accessoriesdata";
import { centralGasesData } from "../../../routes/centralGases/centralGasesData";
import { useState } from "react";

const logo = require("../../../assets/images/logo.png");

function Header() {
  const [showOperationTheaterMenu, setShowOperationTheaterMenu] =
    useState(false);
  const [showCentralGas, setShowCentralGas] = useState(false);
  const [showAccessories, setShowAccessories] = useState(false);
  const [activeAccessory, setActiveAccessory] = useState("");
  const [hideSideBar, setHideSideBar] = useState(true);

  return (
    <>
      <Navbar expand="md" className="main-nav">
        <Container fluid="lg">
          <Link to="/">
            <img src={logo} alt="logo" className="logo" />
          </Link>
          <Navbar.Toggle
            aria-controls={`offcanvasNavbar-expand-md`}
            className="bg-light navbar-toggler"
            onClick={() => {
              setHideSideBar((prevHideBar) => !prevHideBar);
            }}
          />
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-md`}
            aria-labelledby={`offcanvasNavbarLabel-expand-md`}
            placement="end"
            show={hideSideBar === true ? false : true}
          >
            <Offcanvas.Header
              closeButton
              style={{ backgroundColor: "#183B56" }}
              closeVariant="white"
              onHide={() => setHideSideBar((prevHideBar) => !prevHideBar)}
            >
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-md`}>
                <img
                  src={logo}
                  alt="logo"
                  style={{
                    width: "70%",
                  }}
                />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-end align-items-md-center flex-grow-1 pe-3 gap-md-3">
                <NavDropdown
                  title="Operation Theater"
                  id={`offcanvasNavbarDropdown-expand-md`}
                  className="dropDown dropDown-sm-width p-0"
                  drop="down-centered"
                  show={showOperationTheaterMenu}
                  onToggle={() =>
                    setShowOperationTheaterMenu(!showOperationTheaterMenu)
                  }
                  onMouseEnter={() => setShowOperationTheaterMenu(true)}
                  onMouseLeave={() => setShowOperationTheaterMenu(false)}
                >
                  {ProductsData.map((product, index) => {
                    return (
                      <Link
                        key={index}
                        to={
                          product.key === "Control-Panel"
                            ? `products/Control-Panel`
                            : `/products/${product.key}`
                        }
                        className="text-decoration-none text-reset dropDown dropdown-item nav-link-col-light p-2"
                        onClick={() => {
                          setShowOperationTheaterMenu(false);
                          setHideSideBar(true);
                        }}
                      >
                        {product.title}
                      </Link>
                    );
                  })}
                </NavDropdown>
                <Nav.Link href="#" className="ml-5 p-0">
                  Laboratory
                </Nav.Link>
                {centralGasesData.map((state, index) => {
                  return (
                    <NavDropdown
                      title="Central Gas"
                      key={index}
                      id={`offcanvasNavbarDropdown-expand-md`}
                      className="dropDown dropDown-sm-width p-0"
                      drop="down-centered"
                      show={showCentralGas}
                      onMouseEnter={() => setShowCentralGas(true)}
                      onMouseLeave={() => setShowCentralGas(false)}
                      onToggle={() => setShowCentralGas(!showCentralGas)}
                    >
                      {state.instruments.map((accessory, index) => {
                        return (
                          <Link
                            key={index}
                            to={`/centralgas/${accessory?.title
                              .split(/[-\s]+/)
                              .join("-")
                              .toLowerCase()}`}
                            state={{
                              filteredArray: state.instruments,
                              type: state.type,
                              title: accessory?.title,
                            }}
                            className="text-decoration-none text-reset dropDown dropdown-item nav-link-col-light p-2"
                            onClick={() => {
                              setShowCentralGas(false);
                              setHideSideBar(true);
                            }}
                          >
                            {accessory.title}
                          </Link>
                        );
                      })}
                    </NavDropdown>
                  );
                })}
                <NavDropdown
                  title="Accessories"
                  id={`offcanvasNavbarDropdown-expand-md`}
                  className="dropDown dropDown-sm-width"
                  drop="down-centered"
                  show={showAccessories}
                  onMouseEnter={() => setShowAccessories(true)}
                  onMouseLeave={() => setShowAccessories(false)}
                  onToggle={() => setShowAccessories(!showAccessories)}
                >
                  {accessories_array.slice(1).map((state, index) => {
                    return (
                      <NavDropdown
                        title={state.type}
                        id={`offcanvasNavbarDropdown-expand-md`}
                        className="dropDown accessory"
                        show={state.type === activeAccessory ? true : false}
                        drop="end"
                        key={index}
                        onMouseEnter={() => {
                          setActiveAccessory(state.type);
                        }}
                        onMouseLeave={() => {
                          setActiveAccessory(null);
                        }}
                      >
                        {state.instruments.map((accessory, index) => {
                          return (
                            <Link
                              key={index}
                              to={`/accessories/${accessory?.title
                                .split(/[-\s]+/)
                                .join("-")
                                .toLowerCase()}`}
                              state={{
                                filteredArray: state.instruments,
                                from: "home",
                                type: state.type,
                                title: accessory?.title,
                              }}
                              className="text-decoration-none text-reset dropDown dropdown-item nav-link-col-light p-2"
                              onClick={() => {
                                setShowAccessories(false);
                                setHideSideBar(true);
                              }}
                            >
                              {accessory.title}
                            </Link>
                          );
                        })}
                      </NavDropdown>
                    );
                  })}
                </NavDropdown>
                {/* <Nav.Link>
                  <BsSearch size="20px" />
                </Nav.Link> */}
                <Nav.Link href="#" className="request-qoute  mt-3 m-md-0">
                  Request Quote
                </Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
